import ContentLoading from "component/LoadingComponent/ContentLoading";
import Divider from "component/divider/divider";
import { END_POINTS } from "constants/APIConstant";
import { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import NewsDetailsContent from "./components/newsDetailsContent/NewsDetailsContent";
import NewsPdfViewer from "./components/newsPdfViewer/NewsPdfViewer";
import RelatedNews from "./components/relatedNews/RelatedNews";
import TreandingNewsCard from "./components/trendingNews/TreandingNewsCard";
import "./news.scss";
import ReactGA from "react-ga4";

const NewsDetails = () => {
  const { id } = useParams();

  const newsDetailsFetching = useSWR({
    url: `${END_POINTS.NEWS}/${id}`,
  });
  const newstMostViewed = useSWR({
    url: `${END_POINTS.NEWS_GET_MOST_VIEWED}`,
  });
  const newsLatest = useSWR({
    url: `${END_POINTS.NEWS_GET_LATEST}`,
  });
  const relatedNews = useSWR({
    url: `${END_POINTS.NEWS_GET_RELATED}`,
    params: { newsID: id },
  });

  const RenderTrendieCards = ({ trendieArr }) => {
    return trendieArr.data.map(
      ({ title, publishDate, id, newsTranslation }, index) => {
        return (
          <li
            key={`trendie-card-${index}`}
            className="list-of-link trending-cards"
          >
            {index !== 0 && (
              <Divider borderWidth="1px" borderColor="#cfdce5" opacity="0.5" />
            )}
            <TreandingNewsCard
              id={id}
              title={title}
              date={publishDate}
              translations={newsTranslation}
            />
          </li>
        );
      }
    );
  };
  const RenderRelatedNew = () => {
    if (
      relatedNews.isLoading ||
      relatedNews.error ||
      relatedNews.data === undefined
    )
      return <></>;
    return relatedNews.data.data.map(
      ({ title, publishDate, image, id, newsTranslation }, index) => {
        return (
          <Col xs={12} md={6} lg={3} key={index}>
            <RelatedNews
              id={id}
              title={title}
              publicationDate={publishDate}
              image={image}
              translations={newsTranslation}
            />
          </Col>
        );
      }
    );
  };
  const RenderNewsDetails = () => {
    if (newsDetailsFetching.data.data.isPdf) return <NewsPdfViewer newsDetailsFetching={newsDetailsFetching} />;
    return <NewsDetailsContent newsDetailsFetching={newsDetailsFetching} />;
  };

  useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, [id]);


  ReactGA.initialize(END_POINTS.TRACKING_ID);

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({
      hitType: "pageview",
      page: `/mediaLanding/news/${id}`,
      title: `News details title: ${newsDetailsFetching?.data?.data?.title}`
    });
  }, [id]);

  return (
    <ContentLoading
      isLoading={
        newsDetailsFetching.isLoading ||
        newsLatest.isLoading ||
        newstMostViewed.isLoading
      }
      className="news-details"
    >
      {!newsDetailsFetching.error && newsDetailsFetching.data && (
        <Container>
          <Row className="gx-5">
            <Col xs={12} sm={12} md={8} lg={9}>
              <div className="content-section">
                <RenderNewsDetails />
              </div>
              <Row>
                <Divider marginBottom={"30px"} marginTop={"30px"} />
              </Row>
              <Row>
                <Col>
                  <label
                    style={{
                      fontSize: "24px",
                      fontWeight: "bolder",
                      marginBottom: "10px",
                    }}
                  >
                    <FormattedMessage id="related-news" />
                  </label>
                </Col>
              </Row>
              <Row>
                <RenderRelatedNew />
              </Row>
            </Col>
            <Col xs={12} sm={12} md={4} lg={3}>
              <div className="recommended-news-section">
                <div className="most-read">
                  <ul>
                    <li>
                      <label className="header-title pe-3">
                        <FormattedMessage id="most-read" />
                      </label>
                    </li>
                    <RenderTrendieCards
                      trendieArr={
                        newstMostViewed.error || !newstMostViewed.data
                          ? []
                          : newstMostViewed.data
                      }
                    />
                  </ul>
                </div>
                <div className="newest-news">
                  <ul>
                    <li>
                      <label className="header-title pe-3">
                        <FormattedMessage id="newest-news" />
                      </label>
                    </li>
                    <RenderTrendieCards
                      trendieArr={
                        newsLatest.error || !newsLatest.data
                          ? []
                          : newsLatest.data
                      }
                    />
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </ContentLoading>
  );
};

export default NewsDetails;
